import { defineStore } from 'pinia';

export const useMediaQueryStore = defineStore('mediaQuery', () => {
  // STATES
  const {
    isMobile: mobile,
    isTablet: tablet,
    isDesktop: desktop,
  } = useDevice();
  const isMobile = ref(mobile);
  const isTablet = ref(mobile || tablet);
  const isDesktop = ref(desktop);

  const isLessEs = ref(false);
  const isEs = ref(false);
  const isSm = ref(false);
  const isMd = ref(false);
  const isLg = ref(false);
  const isXl = ref(false);
  const isXXl = ref(false);
  const isXMax = ref(false);

  const setIsLessEs = (value: boolean) => {
    if (isLessEs.value !== value) isLessEs.value = value;
  };
  const setIsEs = (value: boolean) => {
    if (isEs.value !== value) isEs.value = value;
  };
  const setIsSm = (value: boolean) => {
    if (isSm.value !== value) isSm.value = value;
  };
  const setIsMd = (value: boolean) => {
    if (isMd.value !== value) isMd.value = value;
  };
  const setIsLg = (value: boolean) => {
    if (isLg.value !== value) isLg.value = value;
  };
  const setIsXl = (value: boolean) => {
    if (isXl.value !== value) isXl.value = value;
  };
  const setIsXXl = (value: boolean) => {
    if (isXXl.value !== value) isXXl.value = value;
  };
  const setIsXMax = (value: boolean) => {
    if (isXMax.value !== value) isXMax.value = value;
  };

  const setIsMobile = (value: boolean) => {
    if (isMobile.value !== value) isMobile.value = value;
  };
  const setIsTablet = (value: boolean) => {
    if (isTablet.value !== value) isTablet.value = value;
  };
  const setIsDesktop = (value: boolean) => {
    if (isDesktop.value !== value) isDesktop.value = value;
  };

  return {
    setIsDesktop,
    setIsTablet,
    setIsMobile,
    isTablet,
    isMobile,
    isDesktop,
    isLessEs,
    isEs,
    isSm,
    isMd,
    isLg,
    isXl,
    isXXl,
    isXMax,
    setIsXMax,
    setIsXXl,
    setIsXl,
    setIsLg,
    setIsMd,
    setIsSm,
    setIsEs,
    setIsLessEs,
  };
});
